export default __webpack_public_path__ + "static/media/test_and_live_mode.dfde4155.svg";